import { inject, observer } from 'mobx-react';
import { handleDeleteSession } from '../../../api/grt/ai';
import { Collapse } from 'antd-mobile';
import s from './style.module.scss';
import { Checkbox } from 'antd-mobile';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import ToastUtils from '../../../utils/ToastUtils';
import { GrtDialog } from '@/utils/Mobile';
import GrtImage from '@/components/GrtImage';
import { RightOutline } from 'antd-mobile-icons';
import MyIcon from '@/components/MyIcon';
import lineImg from '@/assets/images/mobile/line_icon.png';
const SessionList = (props) => {
    let { chatStore, sessionStore } = props.store;
    let { sessionList = {} } = sessionStore;
    let { resetSession } = chatStore;
    const [selectIds, setSelectIds] = useState([]);
    const [edit, setEdit] = useState(false);
    const { state } = props.store.grtAi;
    const { currentAgent = {} } = state;
    // const { sessionList = {} } = props;
    const choseItem = (item) => {
        if (!edit) {
            props.changeSession(item);
            return;
        }
        let data = cloneDeep(selectIds);
        if (data.includes(item.session_id)) {
            data = data.filter((el) => el !== item.session_id); // 删除元素
        } else {
            data.push(item.session_id);
        }

        setSelectIds(data);
    };
    const getSessionList = () => {
        props.getHistorySessionList();
    };
    const handleDelete = async () => {
        let res = await handleDeleteSession({ session_id_list: selectIds });
        if (res && res.success) {
            if (selectIds.includes(props.sessionId)) {
                resetSession();
            }
            ToastUtils.showToast('删除成功');
            setSelectIds([]);
            setEdit(false);
            // getSessionList();
            props.setVisible();
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '删除失败');
        }
    };
    const beforeDelete = () => {
        if (selectIds.length === 0) {
            ToastUtils.showToast('请选择要删除的会话');
            return;
        }
        GrtDialog.confirm({
            content: <b>此操作将永久删除您创建的所有聊天记录，且无法撤销。请确认以继续。</b>,
            onConfirm: handleDelete
        });
    };

    useEffect(() => {
        if (props.visible) {
            getSessionList();
        }
    }, [props.visible]);
    const Title = () => {
        return (
            <div className={s['popup-title']}>
                <GrtImage src={currentAgent?.agent_icon}></GrtImage>
                <span>{currentAgent.name || 'AI少年郎'}</span>
            </div>
        );
    };
    return (
        <div className={s['session-list-box']}>
            <Display show={!currentAgent.description}>
                <div className={s['popup-title-wrap']}>
                    <div className={s['title']}>当前智能体</div>
                    <Title></Title>
                </div>
            </Display>
            <Display show={currentAgent.description}>
                <div className={s['popup-title-wrap']}>
                    <Collapse>
                        <Collapse.Panel key="1" arrowIcon={<MyIcon type="icon-right"></MyIcon>} title={<Title></Title>}>
                            <div className={s['introduction']}>{currentAgent.description}</div>
                        </Collapse.Panel>
                    </Collapse>
                </div>
            </Display>

            <div className={s['latest-session-box']}>
                <div className={s['title']}>
                    <GrtImage src={lineImg}></GrtImage>
                    最近会话
                </div>
                <div className={s['action']}>
                    <Display show={!edit}>
                        <span
                            onClick={() => {
                                setEdit(true);
                            }}
                            data-color="primary"
                        >
                            管理
                        </span>
                    </Display>
                    <Display show={edit}>
                        <span
                            data-color="primary"
                            onClick={() => {
                                setSelectIds([]);
                                setEdit(false);
                            }}
                        >
                            取消
                        </span>
                        <span onClick={beforeDelete} data-color="danger">
                            删除
                        </span>
                    </Display>
                </div>
            </div>
            <div className={s['session-list-wrap']}>
                {Object.keys(sessionList).map((ele, index) => {
                    let obj = sessionList[ele];
                    return obj?.list.length ? (
                        <div className={s['session-group']} key={index}>
                            <div className={s['title']}>{obj?.name}</div>
                            <div className={s['session-item-wrap']}>
                                {obj?.list.map((item, idx) => {
                                    return (
                                        <div
                                            onClick={() => {
                                                choseItem(item);
                                            }}
                                            data-checked={item.session_id === props.sessionId}
                                            key={idx}
                                            className={s['session-item']}
                                        >
                                            <span className={s['item-name']}> {item.session_name}</span>

                                            <span className={s['item-action']} data-show={edit}>
                                                <Checkbox
                                                    checked={selectIds.includes(item.session_id)}
                                                    style={{
                                                        '--icon-size': '16px',
                                                        '--font-size': '14px',
                                                        '--gap': '6px'
                                                    }}
                                                ></Checkbox>
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : null;
                })}
            </div>
            <div></div>
        </div>
    );
};
export default inject('store')(observer(SessionList));
